import React from 'react';
import styled from 'styled-components';

import FilterIcon from '@/assets/svg/icon-filter.svg';
import { colors } from '@/constants/theme';

import { StockShowMoreButtonProps } from './types';

function StockShowMoreButton({ label, onClick }: StockShowMoreButtonProps) {
  return (
    <Component onClick={onClick}>
      {label} <FilterIcon />
    </Component>
  );
}

export default StockShowMoreButton;

const Component = styled.button`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 16px;
  color: ${colors.main};
  transition: 0.3s;
  user-select: none;

  svg {
    margin-left: 15px;

    path {
      fill: ${colors.main};
    }
  }

  &:hover {
    color: ${colors.main100};

    svg {
      path {
        fill: ${colors.main100};
      }
    }
  }
`;
